/**
 * Variables Globales para Movistar Prosegur
 */

export const Globals = {
    /*Id Tag D1C*/
       idTagD1C: "29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953a00cfcbf52c11c9f4d1dcd99c405c00341b6581dff07d907d9e0281a555fdd4db05a14c1ca0d213d37460ae64aa13f2794108ff7fe24a95757d3c6203632050c165892bc5981651e88b5fcb5a51ecfc8f"
}